
export default {
  selection: true,
  reserveSelection:true,
    menu: true,
    border: 'true',
    menuAlign: "center",
    menuType: "button",
    // border:true,
    // excelBtn:true,
    height: "auto",
    calcHeight:90,
    indexLabel: '#',
    index:true,
    addBtn:false,
    delBtn:false,
    searchBtn:false,
    emptyBtn:false,
    refreshBtn:true,
    // header:false,
    editBtn:false,
    // align: "center",
    columnBtn:false,
    menuWidth:150,
    column: [
      {
        showColumn:true,
        "label": "上级单位",
        "prop": "deptName",
        "type": "tree",
      },
      {
        "label": "需求描述",
        "prop": "description",
        width:'140',
        slot:true,
        showColumn:true,
      },
      {
        showColumn:true,
        "label": "报单人",
        "prop": "requireManName",
        "type": "input"
      },
      {
        showColumn:true,
        "label": "联系电话",
        "prop": "requireManPhone",
        width:'100',
        "type": "input"
      },
      {
        showColumn:true,
        "label": "项目地点",
        width:'160',
        "prop": "areaName",
        "type": "tree",
        slot:true,
      },
      {
        showColumn:true,
        sortable:true,
        "label": "下单时间",
        "prop": "createTime",
        width:'140',
        "type": "input"
      },
      {
        showColumn:true,
        "label": "期望解决时间",
        "prop": "expectStartTime",
        width:'140',
        "type": "datetime"
      },
      {
        showColumn:true,
        "label": "紧急程度",
        "prop": "urgentLevel",
        slot:true,
        "type": "input"
      },
      {
        showColumn:true,
        "label": "来电类型",
        width:'120',
        "prop": "moduleName",
      },
      // {
      //   showColumn:false,
      //   "label": "来电类型",
      //   hide:true,
      //   "prop": "moduleType",
      //   // searchslot:true,
      //   slot:true,
      //   searchSpan:24,
      //   width:'120',
      //   "type": "select",
      //   dataType:'string',
      //   props:{
      //     label:'dictValue',
      //     value:'dictKey'
      //   },
      //   // dicUrl:'/api/blade-system/dict/dictionary?code=module_type'
      // },
      {
        showColumn:true,
        "label": "业务类型",
        width:'120',
        "prop": "subModuleName",
      },
      {
        showColumn: true,
        label: "服务类型",
        width:'120',
        prop: "serviceTypeName",
      },
      {
        showColumn:true,
        "label": "工单编号",
        width:'100',
        "prop": "code",
      },
      {
        showColumn:true,
        "label": "工单状态",
        "prop": "workStatus",
        searchSpan:24,
        "type": "select",
        dataType:'string',
        slot:true,
        // searchslot:true,
        props:{
          label:'dictValue',
          value:'dictKey'
        },
        // dicUrl:'/api/blade-system/dict/dictionary?code=order_work_status'
      },
      {
        label:"派单人",
        prop:"appointName",
        showColumn:true,
      },
      {
        label:"派单时间",
        prop:"appointTime",
        width:'140',
        showColumn:true,
      },
      {
        label:"接单人",
        prop:"accpetName",
        showColumn:true,
      },
      {
        label:"接单时间",
        prop:"accpetTime",
        width:'140',
        showColumn:true,
      },
      {
        label:"开始时间",
        prop:"startTime",
        width:'140',
        showColumn:true,
      },
      {
        label:"到场时效",
        prop:"appearAging",
        showColumn:true,
      },
      {
        showColumn:true,
        "label": "负责人",
        "prop": "handerName",
        "type": "input"
      },
      {
        showColumn:true,
        "label": "服务得分",
        width:'80',
        "prop": "serviceItemScore",
      },
      {
        label:"评价结果",
        prop:"serviceEvaluateScore",
        showColumn:true,
      },
      {
        showColumn:true,
        "label": "超时时长",
        "prop": "timeOut",
      },
      {
        label:"服务班组",
        prop:"groupName",
        showColumn:true,
      },
      {
        label:"协同人",
        prop:"cooperateUserNames",
        showColumn:true,
      },
      {
        label:"完成时间",
        prop:"endTime",
        showColumn:true,
      },
      {
        label:"工作时长",
        prop:"workTime",
        showColumn:true,
      },
      {
        label:"耗材",
        prop:"consumableName",
        showColumn:true,
      },
      {
        label:"耗材费用",
        prop:"amount",
        align:"right",
        slot:true,
        showColumn:true,
      },
      
      {
        label:"验收人",
        prop:"checkName",
        showColumn:true,
      },
      {
        label:"验收时间",
        prop:"checkTime",
        showColumn:true,
      },
      {
        label:"评价人",
        prop:"evaluateName",
        showColumn:true,
      },
      {
        label:"评价时间",
        prop:"evaluateTime",
        showColumn:true,
      },
     
      {
        label:"评价内容",
        prop:"evaluateContent",
        showColumn:true,
      },
      {
        label: '投诉次数',
        prop: 'complainedCount',
        showColumn:true,
        width: 120,
      },
      {
        label: '警告次数',
        prop: 'warnCount',
        showColumn:true,
        width: 100,
      },
      // {
      //   showColumn:true,
      //   label: "项目名称",
      //   prop: "projectId2",
      //   type: 'select',
      //   dataType:'string',
      //   props:{
      //     label:'name',
      //     value:'id'
      //   },
      //   dicUrl:'/api/v4ward/project/getProjectList'
      // },
      
    
     
     
      
      
     
      {
        // showColumn:true,
        "label": "项目地点",
        prop: "areaId",
        searchslot:true,
        hide:true,
        "type": "tree",
        showColumn:false,
      },
      
     
    
      
    
      {
        showColumn:false,
        "label": "是否超时",
        "prop": "timeoutFlag",
        dataType: 'number',
        slot:true,
        props:{
          label:'dictValue',
          value:'dictKey'
        },
        dicUrl:'/api/blade-system/dict/dictionary?code=common_flag'
      },
      
    
      
    
      // {
      //   "label": "是否超时",
      //   "prop": "timeoutFlag",
      //   dataType: 'number',
      //   slot:true,
      //   props:{
      //     label:'dictValue',
      //     value:'dictKey'
      //   },
      //   dicUrl:'/api/blade-system/dict/dictionary?code=common_flag'
      // },
      // {
      //   "label": "超时时长",
      //   "prop": "timeOut",
      // },



      // {
      //   "label": "工单状态",
      //   width:'160',
      //   "prop": "orderStatus",
      // },

      // {

      //   label: "项目名称",
      //   prop: "projectId",
      //   type: 'select',
      //   hide:true,
      //   searchslot:true,
      //   showColumn:false,
      // },
    
    
     
     
     
     
      
      // {
      //   "label": "审批",
      //   "prop": "approveFlag",
      //   "type": "select",
      //   dataType: 'number',
      //   slot:true,
      //   props:{
      //     label:'dictValue',
      //     value:'dictKey'
      //   },
      //   dicUrl:'/api/blade-system/dict/dictionary?code=common_flag'
      // },

      // {
      //   showColumn:true,
      //   "label": "剩余时间",
      //   "prop": "timeRemaining",
      //   "type": "input"
      // },

      {

        // "label": " ",
        width:'160',
        searchSpan:24,
        hide:true,
        searchslot:true,
        "prop": "searchContainer",
        showColumn:false,
      },
     /* {
        "label": "创建视角",
        "prop": "orderAngle",
        searchSpan:24,
        "type": "select",
        dataType:'string',
        slot:true,
        // searchslot:true,
        props:{
          label:'dictValue',
          value:'dictKey'
        },
        // dicUrl:'/api/blade-system/dict/dictionary?code=order_work_status'
      },*/
      {
        "label": "状态",
        "prop": "prop10Copy",
        hide:true,
        "type": "select",
        showColumn:false,
      },

    ]
  }
